import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	discordInfo: {
		name: null,
		email: null,
		profileImage: null,
		verifierId: null,
		verifier: null
	},
	backendInfo: {
		id: null,
		walletAddress: null,
		timeCredit: null,
		kycId: null,
		kycStatus: null,
		kycReference: null
	}
};

const appUserSlice = createSlice({
	name: 'appUser',
	initialState,
	reducers: {
		setDiscordInfo: (state, action) => {
			state.discordInfo = action.payload;
		},
		setBackendInfo: (state, action) => {
			state.backendInfo = { ...state.backendInfo, ...action.payload };
		}
	}
});

export const { setDiscordInfo, setBackendInfo } = appUserSlice.actions;

export default appUserSlice.reducer;
